export const errorCode = {
    maxItemsLimitReached: "MAX_ITEMS_LIMIT_REACHED",
    permissionDenied: "PERMISSION_DENIED",
    duplicatedData: "DUPLICATED_DATA",
    existingSubscription: "EXISTING_SUBSCRIPTION",
    freeTrialClaimed: "FREE_TRIAL_CLAIMED",
};
